import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import {
  META_PIXEL_ID,
  loadMetaPixel,
  trackViewContent as metaViewContent,
  trackViewSpecialOfferContent
} from './metaPixel';
import {
  loadTikTokPixel,
  trackViewContent as ttViewContent
} from './tiktokPixel';

// const TIKTOK_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || '';

export default function GiveawayPixels() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;

    // only handle giveaway routes
    if (!path.startsWith('/giveaway')) return;

    // prevent double fire in dev/StrictMode
    if (lastPath.current === path) return;
    lastPath.current = path;

    // load pixels (safe to call repeatedly)
    loadMetaPixel(META_PIXEL_ID);
    // if (TIKTOK_ID) loadTikTokPixel(TIKTOK_ID);

    // ---- events by route ----
    if (path === '/giveaway') {
      // Friend requirement: /giveaway => ViewContent
      metaViewContent({ contentName: 'Giveaway Landing' });
      // ttViewContent({ contentName: 'Giveaway Landing' });
    }

    if (path === '/giveaway/special-offer') {
      // Friend requirement: /giveaway => ViewContent
      trackViewSpecialOfferContent({ contentName: 'Special Offer Page' });
      // ttViewContent({ contentName: 'Giveaway Landing' });
    }

    // later you’ll add:
    // /giveaway/payment => InitiateCheckout
    // /giveaway/confirmation-one-off and /giveaway/confirmation-sub => Purchase
  }, [location.pathname]);

  return null;
}
